export default __webpack_public_path__ + "ernieca8d33.png";